import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useParentsInfoChartsDataContext } from './hooks/useParentsInfoChartsDataContext';

export const MotherRace = () => {
    const { chartData } = useParentsInfoChartsDataContext();


    return (
        <SimpleBars
            title={'Raça/Cor da mãe'}
            horizontal={false}
            subtitles={chartData?.motherRace?.map((item) => item.description)}
            values={chartData?.motherRace?.map((item) => item.total  ||  0)}
        />
    );
};
